import React, { FC } from 'react'

import { WithClassName } from 'common/types'

export const SideBarButtonSvg: FC<
  WithClassName & {
    color?: string
  }
> = ({ className, color = 'white' }) => (
  <svg width="19" height="16" viewBox="0 0 19 16" className={className}>
    <g fill={color} fillRule="evenodd">
      <path d="M17.0625,13.125 C17.787,13.125 18.375,13.713 18.375,14.4375 C18.375,15.162 17.787,15.75 17.0625,15.75 L1.3125,15.75 C0.588,15.75 0,15.162 0,14.4375 C0,13.713 0.588,13.125 1.3125,13.125 L17.0625,13.125 Z M17.0625,6.5625 C17.787,6.5625 18.375,7.1505 18.375,7.875 C18.375,8.5995 17.787,9.1875 17.0625,9.1875 L1.3125,9.1875 C0.588,9.1875 0,8.5995 0,7.875 C0,7.1505 0.588,6.5625 1.3125,6.5625 L17.0625,6.5625 Z M17.0625,0 C17.787,0 18.375,0.588 18.375,1.3125 C18.375,2.037 17.787,2.625 17.0625,2.625 L1.3125,2.625 C0.588,2.625 0,2.037 0,1.3125 C0,0.588 0.588,0 1.3125,0 L17.0625,0 Z" />
    </g>
  </svg>
)
